module.exports = __webpack_public_path__ + "static/media/folder.c0c1f1b6.svg";